import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function CasosExitoList(props: any) {
  useEffect(() => {
    document.title = 'Casos de Éxito';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <FunctionField
          source="portada"
          render={(record: any) => (
            <img
              src={record.portada.url}
              alt={record.portada.alternativeText}
              style={{ width: '120px', height: 'auto' }}
            />
          )}
        />
        <TextField source="nombre" />
        <TextField source="provincia" />
        <TextField source="comuna" />
      </Datagrid>
    </List>
  )
}

export default CasosExitoList;